import { Grid, Grounder } from '@innovamat/glimmer-components';

import { ShortcutsSkeleton } from '../../../../contents';
import { MyClassesSkeleton } from '../../../components/my-classes';

import { Container } from '../styles';

function LandingPageDistrictAdminSkeleton(): JSX.Element {
  return (
    <Container>
      <Grid.Row justifyContent="center">
        <Grid.Col md={10} lg={8}>
          <MyClassesSkeleton />
        </Grid.Col>
      </Grid.Row>

      <Grid.Row justifyContent="center">
        <Grid.Col md={10} lg={8}>
          <ShortcutsSkeleton />
        </Grid.Col>
      </Grid.Row>
      <Grounder />
    </Container>
  );
}

export { LandingPageDistrictAdminSkeleton };
